import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { FaBell, FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { logout as logoutAction } from "../../redux/AuthSlice";
import "./Navbar.css";

export default function Navbar() {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector(state => state.auth);
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const dropdownRef = useRef(null);
  const notificationRef = useRef(null);

  const isActiveLink = (path) => location.pathname === path;

  const handleLogout = () => {
    dispatch(logoutAction());
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <Link to="/">
          <img src="nrks-logo.png" alt="NRKS" />
        </Link>
      </div>

      {/* Hamburger (only for small screens) */}
      <button
        className="mobile-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
      </button>

      {/* Links when user not logged in */}
      {!isAuthenticated && (
        <div className={`nav-links ${isMobileMenuOpen ? "open" : ""}`}>
          <Link className={isActiveLink("/") ? "active" : ""} to="/">Home</Link>
          <Link className={isActiveLink("/courses") ? "active" : ""} to="/courses">Courses</Link>
          <Link className={isActiveLink("/internships") ? "active" : ""} to="/internships">Internships</Link>
          <Link className={isActiveLink("/about") ? "active" : ""} to="/about">About</Link>
          <Link className={isActiveLink("/contact") ? "active" : ""} to="/contact">Contact</Link>
          <Link className="get-started" to="/register" style={{color:"white"}}>Get Started &gt;</Link>
        </div>
      )}

      {/* Logged in navbar */}
      {isAuthenticated && (
        <div className={`logged-in ${isMobileMenuOpen ? "open" : ""}`}>
          <input type="text" placeholder="Search..." className="search-bar" />

          {/* Notifications */}
          <div className="notification" ref={notificationRef}>
            <FaBell size={18} onClick={() => setIsNotificationOpen(!isNotificationOpen)} />
            {isNotificationOpen && <div className="notification-box">Your notifications here</div>}
          </div>

          {/* Profile */}
          <div className="profile" onClick={() => setIsDropdownOpen(!isDropdownOpen)} ref={dropdownRef}>
            <span>{user.name}</span>
            <FaChevronDown size={14} />
            {isDropdownOpen && (
              <div className="dropdown">
                <button>Profile</button>
                <button>Certificates</button>
                <button>Reset Password</button>
                <button onClick={handleLogout}>Logout</button>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
